import * as queryString from "query-string"

const facebookLoginParameters = queryString.stringify({
  client_id: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID,
  redirect_uri: `${process.env.NEXT_PUBLIC_ROOT_URL}/login/customer/facebook`,
  scope: ["email"].join(","), // comma separated string
  response_type: "code",
  auth_type: "rerequest",
  display: "popup",
})

export const facebookLoginUrl = `https://www.facebook.com/v4.0/dialog/oauth?${facebookLoginParameters}`

const googleLoginParameters = queryString.stringify({
  client_id: process.env.NEXT_PUBLIC_GOOGLE_APP_ID,
  redirect_uri: `${process.env.NEXT_PUBLIC_ROOT_URL}/login/customer/google`,
  scope: [
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/userinfo.profile",
  ].join(" "), // space separated string
  response_type: "code",
  access_type: "offline",
  prompt: "consent",
})

export const googleLoginUrl = `https://accounts.google.com/o/oauth2/v2/auth?${googleLoginParameters}`

const facebookSignupParameters = queryString.stringify({
  client_id: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID,
  redirect_uri: `${process.env.NEXT_PUBLIC_ROOT_URL}/signup/customer/facebook`,
  scope: ["email"].join(","), // comma separated string
  response_type: "code",
  auth_type: "rerequest",
  display: "popup",
})

export const facebookSignupUrl = `https://www.facebook.com/v4.0/dialog/oauth?${facebookSignupParameters}`

const googleSignupParameters = queryString.stringify({
  client_id: process.env.NEXT_PUBLIC_GOOGLE_APP_ID,
  redirect_uri: `${process.env.NEXT_PUBLIC_ROOT_URL}/signup/customer/google`,
  scope: [
    "https://www.googleapis.com/auth/userinfo.email",
    "https://www.googleapis.com/auth/userinfo.profile",
  ].join(" "), // space separated string
  response_type: "code",
  access_type: "offline",
  prompt: "consent",
})

export const googleSignupUrl = `https://accounts.google.com/o/oauth2/v2/auth?${googleSignupParameters}`
